import { OrderTotalCards } from "types/cart";
import { priceFormatter } from "helpers/pricing";
import { useDealerContext } from "context/dealer";
interface Props {
  children: React.ReactNode;
    orderTotals: OrderTotalCards;
    showSurcharge: boolean;
    surchargeAmt: number;
    isPaymentTypeCC?: boolean;
}

export const OrderTotalsCard = ({ children, orderTotals, showSurcharge, surchargeAmt, isPaymentTypeCC }: Props) => {
  const { selectedDealerLocation } = useDealerContext();
  const subTotal = orderTotals.SubTotal + orderTotals.Discounts;
  const total = orderTotals.SubTotal + orderTotals.Tax;
  const grandTotal = total + surchargeAmt;
  return (
    <>
      <div className="ta-flex ta-flex-col ta-mt-3.5 ta-justify-end ta-items-center ta-text-base print-totalCard">
        <table className="ta-w-full sm:ta-w-[50%] lg:ta-w-full">
          <tbody className="ta-flex ta-flex-col">
            <tr className="ta-flex ta-justify-between ta-mx-2.5 print-totalContainer">
              <th className="ta-font-normal ta-pb-1 ta-text-left ta-w-[40%] print-left">
                Subtotal
              </th>
              <td className="ta-pl-8 ta-pb-1 ta-text-right ta-w-[60%] print-right">
                ${priceFormatter(subTotal)}
              </td>
            </tr>
            {orderTotals.Discounts === 0 ? (
              ""
            ) : (
              <tr className="ta-flex ta-justify-between ta-mx-2.5">
                <th className="ta-font-normal ta-pb-1 ta-text-left ta-w-[40%] print-left">
                  Discounts
                </th>
                <td className="ta-pl-8 ta-pb-1 ta-text-right ta-w-[60%] print-right">
                  -${priceFormatter(orderTotals.Discounts)}
                </td>
              </tr>
            )}
            <tr className="ta-flex ta-justify-between ta-mx-2.5">
              <th className="ta-font-normal ta-pb-1 ta-text-left ta-w-[40%] print-left">
                Taxes
              </th>
              <td className="ta-pl-8 ta-pb-1 ta-text-right ta-w-[60%] print-right">
                ${priceFormatter(orderTotals.Tax)}
              </td>
            </tr>
            <tr className="ta-flex ta-justify-between ta-mx-2.5 ta-mt-6">
              <th className="ta-text-header ta-text-2xl ta-font-bold ta-text-left ta-w-[40%] print-left">
                Total
              </th>
              <td className="ta-text-header ta-text-2xl ta-font-bold ta-text-right ta-w-[60%] print-right">
                              ${priceFormatter(total)}
              </td>
            </tr>                      
                      <tr className={`ta-flex ta-justify-between ta-mx-2.5 ta-mt-6  ${selectedDealerLocation?.HasCreditCard && selectedDealerLocation?.ApplyCreditCardSurcharge && !showSurcharge && isPaymentTypeCC ? "" : "ta-hidden"}`}>
                          <td className="ta-text-red ta-text-sm ta-w-[100%]">
                              <div className="ta-print-none">
                                  If paying by credit card, a surcharge up to 4% will be applied. Debit & prepaid cards are exempt.
                              </div>
                          </td>
                      </tr>
                      <tr className={`ta-flex ta-justify-between ta-mx-2.5 ta-mt-6 ${surchargeAmt > 0 ? "" : "ta-hidden"}`}>
                          <th className={`ta-font-normal ta-pb-1 ta-text-left ta-w-[40%] ${surchargeAmt > 0 ? "print-left" : "ta-print-none"}`}>
                              Surcharge
                          </th>
                          <td className={`ta-pl-8 ta-pb-1 ta-text-right ta-w-[60%] ${surchargeAmt > 0 ? "print-right" : "ta-print-none"}`}>
                              ${priceFormatter(surchargeAmt)}
                          </td>
                      </tr>
                      <tr className={`ta-flex ta-justify-between ta-mx-2.5 ta-mt-6 ${surchargeAmt > 0 ? "" : "ta-hidden"}`}>
                          <th className={`ta-text-header ta-text-2xl ta-font-bold ta-text-left ta-w-[50%] ${surchargeAmt > 0 ? "print-left" : "ta-print-none"}`}>
                              Grand Total
                          </th>
                          <td className={`ta-text-header ta-text-2xl ta-font-bold ta-text-right ta-w-[50%] ${surchargeAmt > 0 ? "print-right" : "ta-print-none"}`}>
                              ${priceFormatter(grandTotal)}
                          </td>
                      </tr>
          </tbody>
        </table>
      </div>
      {children}
    </>
  );
};
